<div [ngClass]="textClass">
  <m-count-up start="0" [end]="end" [duration]="duration"></m-count-up>
</div>
<div class="h5 text-gray-1000" [ngClass]="subtitleClass">{{ label }}</div>
